import { Component, OnInit } from '@angular/core';
import { ProcessStatus, GiftVoucher } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';

@Component({
  selector: 'app-gift-voucher-home',
  templateUrl: './gift-voucher-home.component.html',
  styleUrls: ['./gift-voucher-home.component.scss']
})
export class GiftVoucherHomeComponent extends BaseComponent implements OnInit {

  public giftVoucherGroups: any[];
  public showView: boolean;

  ngOnInit() {
      this.app.storageService.removeItem(AppConstants.GiftVoucherPendingTransactionHeader);
  }
  
  ngAfterViewInit(): void {
    this.baseTriggerChild.subscribe(() => {
        this.getGiftVouchers();
    });
    this.start();
  }

  getGiftVouchers() {
      this.app.spinner.show();
      const model = {
          branchId: this.app.branch.branchId,
      };
      this.app.webGiftVoucherService.GetGiftVouchers(model)
          .subscribe(
              (data) => {
                  this.app.spinner.hide();
                  this.giftVoucherGroups = data;
                  this.showView = true;
                  this.scrollTo();
              },
              (error) => {
                  this.showView = true;
                  this.app.spinner.hide();
                  this.showErrorMessage(error);
              });
  }

  addToBasket(i: GiftVoucher) {
      if (this.app.stringService.isEmpty(i)) {
          this.showErrorMessage('Please select gift voucher.');
          return;
      }
      this.app.storageService.setItem(AppConstants.GiftVoucherSelectedVoucher, JSON.stringify(i));
      // this.googleAnalyticsService.eventEmitter("Select Gift Voucher", i.name, "Gift Voucher", 1);
      this.app.router.navigate(['add-to-basket']);
  }

}
